// extracted by mini-css-extract-plugin
export default {"statTitle":"Basketball_statTitle--AOF","stat":"Basketball_stat--L_I","container":"Basketball_container--A93"};